<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/league"
                saveRoot="/league"
                @onTrashClick="onTrashClick"
                :formStructure="dataFormStructures.league">
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/league"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de la ligue')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette ligue?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'League',
        components: {
            DynamicForm,
            ModalTrash
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    league: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Ligue'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logo'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'color'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: '',
                                sortable: true
                            },
                            {
                                id: 'description',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Description'),
                                value: '',
                                sortable: true
                            },
                            {
                                id: 'logo',
                                placeholder: Core.Definition.getDefinition('Téléversez une image'),
                                type: 'image',
                                label: Core.Definition.getDefinition('Image'),
                                value: [],
                                thumbnailWidth: 500,
                                maxFilesize: 5
                            },
                            {
                                id: 'color',
                                type: 'color',
                                mode: 'sketch',
                                label: Core.Definition.getDefinition('Couleur'),
                                value: {}
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/participant/ligues')
            }
        }
    }
</script>
